module.exports = __webpack_public_path__ + "static/img/18.144c4ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/temp/18.jpg
// module id = uabH
// module chunks = 36